import {
  Box,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { appImages } from "../../assets";
import GlobalButton from "../../components/button";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import CleaningSubServices from "../../json/ClaningServices.json";
import AllWorkers from "./AllWorkers";
import { t } from "i18next";

const CleaningService = () => {
  const [selectedService, setSelectedService] = useState(null);

  return (
    <>
      <Box
        height={{ xs: "auto", sm: "100vh" }}
        display={"flex"}
        flexDirection={"column"}
        position={"relative"}
        sx={{
          background: (theme) => theme.palette.gradient.background,
          backgroundImage: `url(${appImages.helpPageBgImg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />
        <Container>
          <Grid container height={"80vh"}>
            <Grid
              item
              xs={12}
              md={6}
              p={2}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Typography
                variant="h3"
                fontSize={{ xs: "2rem", sm: "3rem" }}
                fontWeight={500}
                color={"text.white"}
              >
                {t("cleaningServiceHead")}{" "}
              </Typography>
              <Typography variant="body1" mt={2} color={"text.white"}>
                {t("cleaningServiceSubtitle")}
              </Typography>

              <List>
                {CleaningSubServices?.map((val, index) => {
                  const active = selectedService?.name === val.name;
                  return (
                    <ListItem
                      key={index}
                      disableGutters
                      disablePadding
                      onClick={() => setSelectedService(val)}
                      sx={{ cursor: "pointer" }}
                    >
                      <ListItemText
                        sx={{
                          color: "text.white",
                          textTransform: "capitalize",
                          textDecoration: active ? "underline" : null,
                        }}
                      >
                        {index + 1}.{val.name}
                      </ListItemText>
                    </ListItem>
                  );
                })}
              </List>
              <GlobalButton
                variant={"contained"}
                btnText={"selectToSeeProviders"}
                styleProps={{ width: 200, backgroundColor: "text.coralRed" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              position="relative"
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ overflow: "hidden" }}
            >
              {/* Center Image */}
              <Box
                component="img"
                onClick={() => setSelectedService(CleaningSubServices[0])}
                src={CleaningSubServices[0].image}
                alt="Center"
                sx={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "10px",
                  zIndex: 2,
                  objectFit: "cover",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                  cursor: "pointer",
                  border: "2px solid white",
                }}
              />

              {/* Side Images */}
              {CleaningSubServices.map((image, index) => (
                <Box
                  key={index}
                  component="img"
                  src={image.image}
                  alt={`Image ${index + 1}`}
                  onClick={() => setSelectedService(image)}
                  sx={{
                    objectFit: "cover",
                    position: "absolute",
                    top: image.top,
                    left: image.left,
                    right: image.right,
                    bottom: image.bottom,
                    width: "120px",
                    height: "120px",
                    borderRadius: "10%",
                    zIndex: 1,
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                    cursor: "pointer",
                    border: "2px solid white",
                  }}
                />
              ))}
            </Grid>
          </Grid>
        </Container>
      </Box>

      {selectedService && <AllWorkers selectedService={selectedService} />}
      {/* <Services />
      <ServiceProducts /> */}
      <AppFooter />
    </>
  );
};

export default CleaningService;
